module.exports = __webpack_public_path__ + "img/bg09.60baf9ea.gif";